<template>
    <LexinKeyboardLangContent :layout_content="getLayout()" :lang_header="getHeader()" @add-to-search="addToSearchInput"></LexinKeyboardLangContent>
</template>
<script>

import LexinKeyboardLangContent from "@/components/LexinKeyboardLangContent.vue";

export default {
    props: [],
    components: {
        LexinKeyboardLangContent
    },

    methods: {
        getHeader(){
            return this.$t('message.keyboard-urdu');
        },
        getLayout() {
            let layout = {
                default: [
                    '\u0634 \u0633 \u0698 \u0632 \u0691 \u0631 \u0630 \u0688 \u062f \u062e',
                    '\u062d \u0686 \u062c \u062b \u0679 \u062a \u067e \u0628 \u0622 \u0627',
                    '',
                    '\u06d2 \u06cc \u06be \u06c1 \u0648 \u06ba \u0646 \u0645 \u0644 \u06af',
                    '\u06a9 \u0642 \u0641 \u063a \u0639 \u0638 \u0637 \u0636 \u0635',
                    '',
                    '\u0621 \u06d3 \u0626 \u0624',
                    '\u0658 \u064b \u064e \u064f \u0650 \u0670 \u0657 \u0651',
                ],
                shift: []
            };

            return layout;
        },

        addToSearchInput(value) {
            this.$emit('add-to-search', value);
        }
    }
}
</script>
